import { Component } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

export default class TableCellFinancingActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openConfirmation: false,
      publishConfirmation: false,
      openCancel: false,
    };
  }

  handleOpen = () => {
    this.setState({
      openConfirmation: true,
    });
  };

  handleOpenClose = () => {
    this.setState({
      openConfirmation: false,
    });
  };

  handlePublish = () => {
    this.setState({
      publishConfirmation: true,
    });
  };

  handlePublishClose = () => {
    this.setState({
      publishConfirmation: false,
    });
  };

  handleConfirmOpen = () => {
    if (this.props.item.Open == false) {
      this.props.openFinancing(this.props.item.IntId, false);
    } else {
      this.props.closeFinancing(this.props.item.IntId, false);
    }

    this.handleOpenClose();
  };

  handleConfirmPublish = () => {
    if (this.props.item.Published == false) {
      this.props.publishFinancing(this.props.item.IntId);
    } else {
      this.props.unPublishFinancing(this.props.item.IntId);
    }

    this.handlePublishClose();
  };

  handleCancelOpen = () => {
    this.setState({
      openCancel: true,
    });
  };

  handleCancelClose = () => {
    this.setState({
      openCancel: false,
    });
  };

  handleCancelConfirm = () => {
    this.props.cancelFinancing(this.props.item.Id);
    this.handleCancelClose();
  };

  render() {
    const actionsOpen = [
      <Button
        variant="outlined"
        color="primary"
        onClick={this.handleOpenClose}
        key="o-1"
      >
        Close
      </Button>,
      <Button
        variant="contained"
        color="primary"
        keyboardFocused={true}
        onClick={this.handleConfirmOpen}
        key="o-2"
      >
        Confirm
      </Button>,
    ];

    const actionsPublish = [
      <Button
        variant="outlined"
        color="primary"
        onClick={this.handlePublishClose}
        key="p-1"
      >
        Close
      </Button>,
      <Button
        variant="contained"
        color="primary"
        onClick={this.handleConfirmPublish}
        key="p-2"
      >
        Confirm
      </Button>,
    ];

    const cancelActions = [
      <Button
        variant="outlined"
        color="primary"
        keyboardFocused={true}
        onClick={this.handleCancelConfirm}
        key="c-1"
      >
        Confirm cancel
      </Button>,
      <Button
        variant="contained"
        keyboardFocused={false}
        onClick={this.handleCancelClose}
        key="c-2"
      >
        Abort cancel
      </Button>,
    ];

    return (
      <div className="table-cell-actions">
        {this.props.item.Open == false ? (
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleOpen}
            style={{ marginRight: "3px" }}
          >
            Open
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleOpen}
            style={{ marginRight: "3px" }}
          >
            Close
          </Button>
        )}
        {this.props.item.Published == false ? (
          <Button
            variant="contained"
            color="primary"
            onClick={this.handlePublish}
            style={{ marginRight: "3px" }}
          >
            Publish
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={this.handlePublish}
            style={{ marginRight: "3px" }}
          >
            Unpublish
          </Button>
        )}
        {/* <Button variant="contained" color="primary"    onClick={this.handleCancelOpen} >Cancel</Button> */}
        {/* TODO: Remove all code related to cancelling. Cancel does not exist any more */}
        <Dialog
          title="Financing operation"
          modal={false}
          open={this.state.openConfirmation}
          onClose={this.handleOpenClose}
        >
          <DialogContent>
            {" "}
            {this.props.item.Open == false
              ? "Open financing"
              : "Close financing"}
          </DialogContent>
          <DialogActions>{actionsOpen}</DialogActions>
        </Dialog>
        <Dialog
          title="Financing operation"
          modal={false}
          open={this.state.publishConfirmation}
          onClose={this.handlePublishClose}
        >
          <DialogContent>
            {(this.props.item.Published == false
              ? "Publish financing"
              : "Unpublish financing") +
              " with id: " +
              this.props.item.IntId}
          </DialogContent>
          <DialogActions>{actionsPublish}</DialogActions>
        </Dialog>
        <Dialog
          title="Financing operation"
          modal={false}
          open={this.state.openCancel}
          onClose={this.handleCancelClose}
        >
          <DialogContent>Cancel financing? </DialogContent>
          <DialogActions>{cancelActions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}
